// Copyright (c) 2017 Deere & Company

import ClaimsInProgressContainer from '../../claim/claims-in-progress/components';

export default {
    component: ClaimsInProgressContainer,
    name: 'CLAIMS_IN_PROGRESS',
    path: 'claims-in-progress'
};



// WEBPACK FOOTER //
// ./src/routes/claims/claims-in-progress.js